// Only public, non-personal static options. No new persistent cache or API credentials.
export function createPublicCatalogueReader({ fetchImpl = (...args) => fetch(...args), timeoutMs = 5000 } = {}) {
  const pending = new Map();
  return async function readPublicCatalogue(name) {
    if (!['countries.json', 'currencies.json'].includes(name)) return false;
    if (pending.has(name)) return pending.get(name);
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), timeoutMs);
    const operation = (async () => {
      try {
        const response = await fetchImpl(`/data/${name}`, { signal: controller.signal, credentials: 'omit' });
        if (!response.ok) return false;
        const data = await response.json();
        return Array.isArray(data) ? data : false;
      } catch {
        return false;
      } finally {
        clearTimeout(timeout);
      }
    })();
    pending.set(name, operation);
    try {
      return await operation;
    } finally {
      if (pending.get(name) === operation) pending.delete(name);
    }
  };
}

export const readPublicCatalogue = createPublicCatalogueReader();
